var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.139,
    height: 19.5,
    viewBox: "0 0 19.139 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.345-.024a7.345,7.345,0,1,0,0,14.69,11.035,11.035,0,0,0,4.278-1.2,6.55,6.55,0,0,0,.43.527l4.9,5.023a1.1,1.1,0,0,0,1.746,0,1.078,1.078,0,0,0,0-1.734l-5.4-5.4a2.1,2.1,0,0,0-.336-.273c.567-1.028,1.75-3.051,1.75-4.31A7.353,7.353,0,0,0,7.366-.045Zm0,2.1a5.222,5.222,0,0,1,5.247,5.247,5.262,5.262,0,0,1-1.385,3.61l-.063.063a2.1,2.1,0,0,0-.273.273,5.251,5.251,0,0,1-3.547,1.322,5.247,5.247,0,1,1,0-10.493Z",
    transform: "translate(0 0.045)",
    fill: "#adadad"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fde5dc5053ffdba159004a1919ff6bcd.svg";
export { ForwardRef as ReactComponent };